<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
      v-card
        v-card-title.px-5(style="height:56px")
          .h6.basic800--text(v-if="requiredContact") Fill in required field
          .h6.basic800--text(v-else-if="customer") {{ $t('title_edit') }}
          .h6.basic800--text(v-else) {{ $t('title_add') }}
        v-divider.basic300

        v-card-text.pa-0
          v-form(ref="form")
            div.pa-4(style="overflow-x: hidden;")

              .name
                .label.basic600--text.text-uppercase.mb-1 {{ $t('name.label') }}
                v-text-field.mt-2(v-model='form.name' :placeholder="$t('name.placeholder')" background-color="basic200" outlined dense height="40" :rules="rules.not_empty")
              
              .phone
                .mb-1.label.basic600--text.text-uppercase {{ $t('phone.label') }}
                  span(v-if="requiredContact")  (Required)
                v-text-field.mt-2(v-model='form.phone' :placeholder="$t('phone.placeholder')" background-color="basic200" height="40" type="tel" outlined dense persistent-hint :rules="requiredContact || form.phone ? rules.phone : []" @keypress="isNumber($event)")

              .email
                .mb-1.label.basic600--text.text-uppercase {{ $t('email.label') }}
                v-text-field.mt-2(v-model='form.email' :placeholder="$t('email.placeholder')" background-color="basic200" height="40" outlined dense persistent-hint :rules="form.email ? rules.valid_email : []" type="email")
              
              .address(v-if="!requiredContact")
                .activator(v-if="!showAddressFields")
                  .label.basic600--text.text-uppercase.mb-1 {{ $t('address.label') }}
                  v-text-field.mt-2(:placeholder="$t('address.placeholder')" background-color="basic200" outlined dense height="40" readonly @click="showAddressFields = true")
                    template(v-if="!showAddressFields" v-slot:append)
                      eva-icon(name="plus-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic600" @click="showAddressFields = true")
                .fields(v-else)
                  .mb-3.label.basic600--text.text-uppercase adress line 1
                  v-text-field.p1(background-color="basic200" height="40" v-model="address.address_1" :placeholder="$t('address_1.placeholder')" outlined dense :rules="containAddress ? rules.not_empty : []")
                  .mb-3.label.basic600--text.text-uppercase adress line 2
                  v-text-field.p1(background-color="basic200" height="40" v-model="address.address_2" :placeholder="$t('address_2.placeholder')" outlined dense :rules="containAddress ? rules.not_empty : []")
                  .mb-3.label.basic600--text.text-uppercase postcode
                  v-text-field.p1(background-color="basic200" height="40" v-model="address.postcode" :placeholder="$t('postcode.placeholder')" outlined dense :rules="containAddress ? rules.not_empty : []")
                  .mb-3.label.basic600--text.text-uppercase city
                  v-text-field.p1(background-color="basic200" height="40" v-model="address.city" :placeholder="$t('city.placeholder')" outlined dense :rules="containAddress ? rules.not_empty : []")
                  .mb-3.label.basic600--text.text-uppercase state
                  v-text-field.p1(background-color="basic200" height="40" v-model="address.state" :placeholder="$t('state.placeholder')" outlined dense :rules="containAddress ? rules.not_empty : []")
                  .mb-3.label.basic600--text.text-uppercase country
                  v-text-field.p1(background-color="basic200" height="40" v-model="address.country" :placeholder="$t('country.placeholder')" outlined dense :rules="containAddress ? rules.not_empty : []")

        v-card-actions
          v-spacer
          v-btn(color='white', text @click='showModal = false')
            .button-Aa-medium.primary400--text Cancel
          v-btn.mr-2(color='textColorAccent' depressed height=32 @click="clickSave" :loading="isLoading" dark)
            .button-AA-medium.basic100--text {{ $t('save') }}

</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'AddCustomerDialog',
  props: ['open', 'parentCustomer', 'company', 'requiredContact'],
  data: () => ({
    form: {
      source: 'manual',
      name: null,
      email: null,
      phone: null,
      address: null
    },
    address: {
      address_1: null,
      address_2: null,
      postcode: null,
      city: null,
      state: null,
      country: "Malaysia"
    },
    showAddressFields: false,
    isLoading: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      phone: [
        v => /^(\+?6?01)[0-46-9]-*[0-9]{7,8}$/.test(v) || 'Phone Number must be valid',
      ],
      valid_email: [v => !!v || 'Email is required', v => /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Invalid email address']
    }
  }),
  computed: {
    customer: {
      get() {
        return this.parentCustomer
      },
      set(newValue) {
        this.$emit('update:parentCustomer', newValue)
      }
    },
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    containAddress () {
      if (this.address.address_1) {
        return true
      }
      return false
    }
  },
  mounted () {
    if (this.customer) {
      this.form = { ...this.customer }
      if (this.form.address) {
        this.showAddressFields = true
        this.address = { ...this.form.address }
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      if (this.showAddressFields && this.containAddress) {
        this.form.address = this.address
      } else {
        delete this.form.address
      }
      this.isLoading = true
      if (this.customer) {
        if (!this.customer.id) {
          this.$emit('edited', this.form)
          this.showModal = false
          return
        }
        this.axios.patch(`/books/${this.company.slug}/customers/${this.customer.id}/`, this.form)
          .then(resp => {
            this.showMessage(['success', this.$t('success_message.customer_edited')])
            this.$emit('edited', resp.data)
            this.showModal = false
          })
          .catch(e => {
            if (e.response && e.response.data) {
              this.showMessage(['error', e.response.data[0]])
            } else {
              this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
            }
          })
          .finally(() => {
            this.isLoading = false
          })
          return
      }
      this.axios.post(`/books/${this.company.slug}/customers`, this.form)
        .then(resp => {
          this.showMessage(['success', this.$t('success_message.customer_created')])
          this.$emit('added', resp.data)
          this.showModal = false
        })
        .catch(e => {
          if (e.response && e.response.data) {
            this.showMessage(['error', e.response.data[0]])
          } else {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "title_edit": "Edit customer",
    "title_add": "Create new customer",
    "name": {
      "label": "Name (Required)",
      "placeholder": "Write customer name here"
    },
    "email": {
      "label": "Email",
      "placeholder": "Enter email address"
    },
    "phone": {
      "label": "Phone",
      "placeholder": "Write phone number here"
    },
    "address": {
      "label": "Address",
      "placeholder": "Enter customer address"
    },
    "address_1": {
      "label": "Address Line 1",
      "placeholder": "e.g. K-3-01, Conezion, Persiaran IRC3"
    },
    "address_2": {
      "label": "Address Line 2",
      "placeholder": "e.g. IOI Resort City"
    },
    "postcode": {
      "label": "Postcode",
      "placeholder": "e.g. 62502"
    },
    "city": {
      "label": "City",
      "placeholder": "e.g. Putrajaya"
    },
    "state": {
      "label": "State",
      "placeholder": "e.g. Wilayah Persekutuan Putrajaya"
    },
    "country": {
      "label": "Country",
      "placeholder": "e.g. Malaysia"
    },
    "add": "Add",
    "save": "Save"
  }
}
</i18n>
